var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCardLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 35V31.5C40.5 29.567 38.933 28 37 28C35.067 28 33.5 29.567 33.5 31.5V35M44 20H4M44 22V16.4C44 14.1598 44 13.0397 43.564 12.184C43.1805 11.4314 42.5686 10.8195 41.816 10.436C40.9603 10 39.8402 10 37.6 10H10.4C8.15979 10 7.03969 10 6.18404 10.436C5.43139 10.8195 4.81947 11.4314 4.43597 12.184C4 13.0397 4 14.1598 4 16.4V31.6C4 33.8402 4 34.9603 4.43597 35.816C4.81947 36.5686 5.43139 37.1805 6.18404 37.564C7.03969 38 8.15979 38 10.4 38H22M33.2 43H40.8C41.9201 43 42.4802 43 42.908 42.782C43.2843 42.5903 43.5903 42.2843 43.782 41.908C44 41.4802 44 40.9201 44 39.8V38.2C44 37.0799 44 36.5198 43.782 36.092C43.5903 35.7157 43.2843 35.4097 42.908 35.218C42.4802 35 41.9201 35 40.8 35H33.2C32.0799 35 31.5198 35 31.092 35.218C30.7157 35.4097 30.4097 35.7157 30.218 36.092C30 36.5198 30 37.0799 30 38.2V39.8C30 40.9201 30 41.4802 30.218 41.908C30.4097 42.2843 30.7157 42.5903 31.092 42.782C31.5198 43 32.0799 43 33.2 43Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardLock);
export default __webpack_public_path__ + "static/media/credit-card-lock.e2012753aa592f796e902d78f295b2be.svg";
export { ForwardRef as ReactComponent };